import { alpha, Box, styled } from '@mui/material'

export const Wrapper = styled(Box)`
  flex: 1;
  position: relative;
`

export const TableLoader = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => alpha(theme.palette.custom.white, 0.5)};
  z-index: 1;
`

export const SearchWrapper = styled(Box)`
  padding-bottom: 2px;
  position: absolute;
  left: 0;
  top: 0;
  width: 340px;
  height: 48px;
  z-index: 100;
`
